import { clearPendingRequest } from 'actions/composition/lib/update_conversation_workflow';
import ErrorReporter from 'scripts/infrastructure/error_reporter';

export default class OutgoingChatGatewayObserver {
  constructor(context) {
    this.context = context;
  }

  handleAddSuccess(payload) {}

  handleUpdateSuccess(entityId, payload, correlationId) {
    clearPendingRequest(this.context, correlationId);
  }

  handleAddErrors(payload) {
    ErrorReporter.reportError(`Unhandled chat send error: ${JSON.stringify(payload)}`);
  }

  handleUpdateErrors(entityId, payload, correlationId) {
    clearPendingRequest(this.context, correlationId);

    ErrorReporter.reportError(`Failed to update outgoing chat: ${JSON.stringify(payload)}`, {
      extra: { chatId: entityId },
    });
  }
}



// WEBPACK FOOTER //
// ./src/scripts/application/actions/composition/outgoing_chat_gateway_observer.js